import React from 'react'
import { Link } from "react-router-dom"

import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import moment from 'moment'


import Nav from './Nav'

const axios = require('axios')



class Home extends React.Component {

	state = {

	}

	constructor(props) {
		super(props)
	}

	componentDidMount() {
		if (this.props.appState.sessionToken) {
			this.listAWS()
		}
	}

	componentDidUpdate(prev) {
		if (!prev.appState.sessionToken && this.props.appState.sessionToken) {
			// console.log(prev, this.props, this.props.appState.sessionToken);
			this.listAWS()
		}
	}

	render() {
		return (
			<>
				{(this.props.appState.currentUser === undefined) &&
					<div className="my-5 py-5 text-center"><div className="spinner-border"></div></div>
				}

				{(this.props.appState.currentUser === null) &&
					<div className="container text-center my-5 py-5">

						<div className="h1"><img src="/reconfig-logo.svg" className="logo" /></div>
						{/* <div className="lead text-center text-muted my-3">Optimize your Cloud Infrastructure</div> */}

						<div className="text-center my-5 py-5">
							<Link to="/profile" className="btn btn-primary btn-lg d-inline-block mb-2">Sign Up</Link><br />
							<Link to="/login?mode=login" className="small d-inline-block">Log In</Link>
						</div>

					</div>
				}

				{(this.props.appState.currentUser) &&
					this.renderUser()
				}
			</>
		)
	}

	renderGuest() {

	}

	renderUser = () => {
		return (
			<>
				<Nav {...this.props} ></Nav>

				<div className="container-fluid">
					{(!this.props.appState.currentUserAttributes['custom:AWSRoleARN']) &&
						<div className="text-center my-5 py-5">
							<div className="d-inline-block bg-light rounded p-3 mb-5">
								<div className="font-weight-600">Missing AWS Configuration!</div>
								<Link to="/profile" className="small d-inline-block">Update Profile</Link>
							</div>
						</div>
					}

					{(this.props.appState.currentUserAttributes['custom:AWSRoleARN']) &&
						<div className=" mt-4 mb-5 ">

							{this.state.scanning &&
								<div className="my-5 py-5 text-center"><div className="spinner-border"></div></div>
							}

							{(this.state.awsScanError) &&
								<div className="text-center my-5">
									<div className="d-inline-block bg-light rounded p-3 mb-5">
										<div className=""><i className="icon ion-ios-alert"></i> {this.state.awsScanError}</div>
									</div>
								</div>
							}

							{this.state.awsList && this.state.awsList.s3 &&
								this.renderReport()
							}

						</div>
					}

				</div>

			</>
		)
	}

	scrollTo(id) {
		// console.log('scroll', el, window);
		let el = window.document.getElementById(id)
		el && el.scrollIntoView()
	}

	renderReport() {
		return (
			<div className="row my-4 ">
				<div className="col-lg-3 col-xl-2 ">

					<div className="sticky-top py-3">

						<div className="text-center mb-3">
							<button className="btn btn-lg btn-primary btn-block shadow-sm" onClick={this.scanAWS} disabled={this.state.scanning ? 'disabled' : ''}>
								Scan AWS
							</button>
						</div>

						<div className="list-group ">
							{this.services.map(service =>
								<a role="button" className="list-group-item list-group-item-action bg-light border-0 d-flex justify-content-between align-items-center" key={service.id} onClick={() => this.scrollTo(service.id)}>
									{service.title} {Home.renderIssueCount(this.serviceComponents(service.id))}
								</a>
							)}

							<a className="list-group-item list-group-item-action bg-light border-0 disabled d-flex justify-content-between align-items-center">EC2 <span className="smaller opacity-50 text-uppercase">Coming Soon</span></a>
						</div>
					</div>

				</div>
				<div className="col-lg-9 col-xl-10">
					<div style={{ height: '1px' }}></div>

					{this.renderAWS_IAM()}
					{this.renderAWS_S3()}

				</div>
			</div>


		)
	}

	static renderIssueCount(components) {
		let number = this.componentsIssueCountNumber(components)
		let status = this.componentsIssueCountStatus(components)
		return (
			!!number && <span className={" " + this.statusClass(status)}> <small className="font-weight-600">{number}</small> <i className={" icon " + this.statusIcon(status)}></i> </span>
		)
	}


	static ServiceReport(props) {
		return (
			<>
				<div id={props.id}></div>
				<div className="border rounded shadow-sm overflow-hidden  mt-3" >
					<div className="h5 p-3 m-0 bg-light">{props.title}</div>
					{props.children}
				</div>
			</>
		)
	}
	static ComponentReport(props) {
		return (
			<>
				<div className="border-top bg-white p-3">
					<div className="row xalign-items-center">
						<div className="col-md-6">
							{props.children}
						</div>
						<div className="col-md-6">
							{Home.renderComponentStatus(props.component)}
						</div>
					</div>
				</div>
			</>
		)
	}





	renderAWS_S3() {
		return (
			<Home.ServiceReport id="s3" title="S3">

				{this.state.awsList.s3.map((bucket, i) =>
					<Home.ComponentReport component={bucket} key={i}>

						<div className="small text-uppercase opacity-50">Bucket Name</div>
						<div className="h6">{bucket.name}</div>

						{!bucket.scanning &&
							<>
								<div className="d-inline-block mr-4">
									<div className="small text-uppercase opacity-50 mt-3">Total Size</div>
									<div className="">{Home.formatBytes(bucket.info.totalSize)}</div>
								</div>
								<div className="d-inline-block mr-4">
									<div className="small text-uppercase opacity-50 mt-3">Estimated Storage Cost</div>
									<div className="">${bucket.info.totalCost.toFixed(2)}</div>
								</div>
								<div className="d-inline-block align-top mr-4">

									{bucket.info.sizeByClass &&
										<OverlayTrigger
											trigger="click"
											placement="bottom"
											delay={{ show: 250, hide: 400 }}
											overlay={
												<Tooltip className="text-left" >
													<div className="small text-uppercase text-left opacity-50">By Class</div>
													{bucket.info.sizeByClass.map(sbc =>
														<div className="text-left " key={sbc.class}>{sbc.class}: &nbsp; {Home.formatBytes(sbc.size)} &nbsp; ${sbc.cost.toFixed(2)}</div>
													)}
												</Tooltip>
											}
										>
											<div className="small text-secondary font-weight-500 mt-3" role="button">Details <i className={"mr-1 icon ion-ios-arrow-down"}></i></div>
										</OverlayTrigger>
									}

								</div>
							</>
						}
					</Home.ComponentReport>

				)}
			</Home.ServiceReport>
		)
	}

	renderAWS_IAM() {
		return (
			<Home.ServiceReport id="iam" title="IAM">

				<Home.ComponentReport component={this.state.awsList.iam.passwordPolicy}>
					<div className="h6">Password Policy</div>
					{['adminReset', 'expiration', 'length', 'lowercase', 'number', 'preventReuse', 'symbol', 'uppercase', 'userChangable'].map(k =>
						<div className="small" key={k}>
							<i className={"h5 mr-2 icon " + (this.state.awsList.iam.passwordPolicy.componentInfo[k].active ? 'ion-ios-checkmark text-success' : 'ion-ios-close opacity-50')}></i>
							<span className={"" + (this.state.awsList.iam.passwordPolicy.componentInfo[k].active ? '' : 'opacity-50')}>{this.state.awsList.iam.passwordPolicy.componentInfo[k].description}</span>
						</div>
					)}
				</Home.ComponentReport>


				{this.state.awsList.iam.users.map((user, i) =>
					<Home.ComponentReport component={user} key={i}>
						{this.renderUserGroup(user, 'User')}
					</Home.ComponentReport>
				)}

				{this.state.awsList.iam.roles.map((role, i) =>
					<Home.ComponentReport component={role} key={i}>
						{this.renderUserGroup(role, 'Role')}
					</Home.ComponentReport>
				)}

				{this.state.awsList.iam.groups?.map((group, i) =>
					<Home.ComponentReport component={group} key={i}>
						{this.renderUserGroup(group, 'Group')}
					</Home.ComponentReport>
				)}

				{this.state.awsList.iam.policies.map((policy, i) =>
					<Home.ComponentReport component={policy} key={i}>
						{this.renderUserGroup(policy, 'Policy')}
					</Home.ComponentReport>
				)}


			</Home.ServiceReport>
		)
	}



	renderUserGroup(component, label) {
		return (
			<>
				<div className="h6">{label}</div>

				<div className="xd-inline-block mr-4 my-4">
					<div className="small text-uppercase opacity-50 mt-3">{label} Name</div>
					<div className="">{component.componentInfo.name}</div>
				</div>

				{component.componentInfo.created &&
					<div className="xd-inline-block mr-4 my-4">
						<div className="small text-uppercase opacity-50 mt-3">Created</div>
						<div className="">{moment(component.componentInfo.created).format("YYYY-MM-DD HH:mmA")}</div>
					</div>
				}

				<div className="small d-inline-block mr-4">
					<i className={"h5 mr-2 icon " + (component.componentInfo.adminAccess ? 'ion-ios-checkmark text-success' : 'ion-ios-close opacity-50')}></i>
					<span className={"" + (component.componentInfo.adminAccess ? '' : 'opacity-50')}>Admin Access</span>
				</div>
				<div className="small d-inline-block mr-4">
					<i className={"h5 mr-2 icon " + (component.componentInfo.iamAccess ? 'ion-ios-checkmark text-success' : 'ion-ios-close opacity-50')}></i>
					<span className={"" + (component.componentInfo.iamAccess ? '' : 'opacity-50')}>IAM Access</span>
				</div>

			</>
		)
	}

	static renderComponentStatus(component) {
		let security = component.security || component
		return (
			<>
				{component.scanning &&
					<div className={"h5 mb-0 text-secondary"}>
						<span className="spinner-border spinner-border-sm align-baseline" ></span> Scanning
					</div>
				}

				{!component.scanning &&
					<>
						{component.scanDetails && !!component.scanDetails.lastScanDate &&
							<div className="small opacity-50 mb-3">
								Scanned {moment(component.scanDetails.lastScanDate * 1000).format("YYYY-MM-DD HH:mmA")}
							</div>
						}

						{security.status &&
							<div className={"h5 mb-3 " + this.statusClass(security.status)}>
								<i className={"h3 mr-1 icon " + this.statusIcon(security.status)}></i> {this.statusText(security.status)}
							</div>
						}
						{security.issues && security.issues.map((issue, i) =>
							<div key={i} className={" " + this.statusClass(issue.severity)}>
								<i className={"h5 mr-1 icon " + this.statusIcon(issue.severity)}></i> {issue.description}

								{issue.resolution &&
									<OverlayTrigger
										trigger="click"
										placement="bottom"
										delay={{ show: 250, hide: 400 }}
										overlay={
											<Tooltip >
												<div className="text-left">{issue.resolution}</div>
												{issue.url &&
													<div className="text-left mt-1 font-weight-600">
														<i className={"mr-2 icon ion-ios-information-circle-outline"}></i>
														<a href={issue.url} target="_blank" className="text-reset">More info</a>
													</div>
												}
												<div className="text-left mt-1 font-weight-600">
													<i className={"mr-2 icon ion-ios-help-circle-outline"}></i>
													<a href="mailto:contact@reconfig.cloud" target="_blank" className="text-reset">Need Help? Contact us</a>
												</div>
											</Tooltip>
										}
									>
										<div className="d-inline-block small text-secondary font-weight-500 ml-2 mt-3" role="button">Details <i className={"mr-1 icon ion-ios-arrow-down"}></i></div>
									</OverlayTrigger>
								}

							</div>
						)}
						{component.errors && component.errors.map((issue, i) =>
							<div key={i} className={" text-secondary"}>
								<i className={"h5 mr-1 icon ion-ios-alert"}></i> {issue}
							</div>
						)}

					</>
				}
			</>
		)
	}













	listAWS = async () => {
		this.setState({ scanning: true, awsList: null, awsScanError: null })

		// FAKE
		// setTimeout(() => {
		// 	this.setState({ scanning: false, awsS3Scan: require('./fakeAwsScan.json') })
		// }, 2000)

		try {

			let awsListResponse = await axios.get('https://api.reconfig.cloud/v1/list', { headers: { 'Authorization': this.props.appState.sessionToken } })
			awsListResponse.data.s3 = awsListResponse.data.s3.sort((a, b) => {
				return a.name.localeCompare(b.name)
			})
			console.log(awsListResponse.data);
			this.setState({ scanning: false, awsList: awsListResponse.data })

		} catch (error) {
			console.log('error', error);
			this.setState({ scanning: false, awsScanError: "Error scanning AWS. Make sure your Keys are correct." })
		}

	}

	scanAWS = async () => {

		this.scanIAM()
		for (const index in this.state.awsList.s3) {
			this.scanS3Bucket(index)
		}

	}

	async scanS3Bucket(index) {
		// let bucket = this.state.awsList.s3[index]
		// console.log('scanS3Bucket', index, this.state.awsList.s3[index]);

		this.state.awsList.s3[index].scanning = true
		this.setState({ awsList: this.state.awsList })

		try {
			let awsS3ScanResponse = await axios.post('https://api.reconfig.cloud/v1/s3/scan', { bucket: this.state.awsList.s3[index].name }, { headers: { 'Authorization': this.props.appState.sessionToken } })
			console.log(awsS3ScanResponse.data);
			this.state.awsList.s3[index] = awsS3ScanResponse.data
			this.setState({ awsList: this.state.awsList })
		} catch (error) {
			this.state.awsList.s3[index].scanning = false
			this.state.awsList.s3[index].security.status = 'error'
			this.setState({ awsList: this.state.awsList })
		}

	}

	async scanIAM() {

		this.state.awsList.iam.passwordPolicy.scanning = true
		this.setState({ awsList: this.state.awsList })

		try {
			let awsIAMScanResponse = await axios.get('https://api.reconfig.cloud/v1/iam/scan', { headers: { 'Authorization': this.props.appState.sessionToken } })
			console.log(awsIAMScanResponse.data);
			this.state.awsList.iam = awsIAMScanResponse.data
			this.setState({ awsList: this.state.awsList })
		} catch (error) {
			this.state.awsList.iam.passwordPolicy.scanning = false
			this.state.awsList.iam.passwordPolicy.status = 'error'
			this.setState({ awsList: this.state.awsList })
		}

	}

	services = [
		{ id: 'iam', title: 'IAM' },
		{ id: 's3', title: 'S3' },
	]
	serviceComponents(service) {
		switch (service) {
			case 'iam': return [this.state.awsList.iam.passwordPolicy].concat(this.state.awsList.iam.users, this.state.awsList.iam.groups, this.state.awsList.iam.roles, this.state.awsList.iam.policies)
			case 's3': return this.state.awsList.s3
			default: return []
		}
	}






	static componentsIssueCountNumber(components) {
		if (!components) return 0
		return components.reduce((result, c, i, a) => {
			if (!c || c.scanning) return result + 0
			return result + this.componentIssueCountNumber(c)
		}, 0)
	}
	static componentsIssueCountStatus(components) {
		let statuses = components.reduce((result, c, i, a) => {
			return result.concat(this.componentIssueCountStatus(c))
		}, [])
		return this.mostSevereStatus(statuses)
	}

	static componentIssueCountNumber(component) {
		if (!component) return 0
		if (component.scanning) return 0
		let security = component.security || component
		return (security.issues ? security.issues.length : 0) + (component.errors ? component.errors.length : 0)
	}
	static componentIssueCountStatus(component) {
		if (!component) return []
		if (component.scanning) return []
		let security = component.security || component
		let statuses = [].concat((security.issues ? security.issues.map(i => i.severity) : [])).concat((component.errors ? component.errors.map(i => 'error') : []))
		return this.mostSevereStatus(statuses)
	}

	static mostSevereStatus(statuses) {
		if (statuses.includes('critical')) return 'critical'
		if (statuses.includes('warning')) return 'warning'
		if (statuses.includes('error')) return 'error'
		return 'ok'
	}
	static statusText(status) {
		switch (status) {
			case 'critical': return 'Critical'
			case 'warning': return 'Warning'
			case 'error': return 'Error'
			case 'ok': return 'OK'
			default: return ''
		}
	}
	static statusIcon(status) {
		switch (status) {
			case 'critical': return 'ion-ios-flame'
			case 'warning': return 'ion-ios-warning'
			case 'error': return 'ion-ios-alert'
			case 'info': return 'ion-ios-information-circle'
			case 'ok': return 'ion-ios-checkmark-circle'
			default: return ''
		}
	}
	static statusClass(status) {
		switch (status) {
			case 'critical': return 'text-danger'
			case 'warning': return 'text-warning'
			case 'error': return 'text-secondary'
			case 'info': return 'text-secondary'
			case 'ok': return 'text-success'
			default: return ''
		}
	}

	static formatBytes(bytes, decimals = 2) {
		if (bytes === 0) return '0 Bytes';

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}



}

export default Home
